module.exports = __webpack_public_path__ + "img/logo_only_circle.075bc0ad.png";